import React from 'react';
import axios from 'axios';

import Loading from './Loading'

import styles from '../styles/DynamicModal.module.css';

const AgreedAMsForCase = ({ idCase, onAppointmentSuccess }) => {
    const [applications, setApplications] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [status, setStatus] = React.useState('');
    const [error, setError] = React.useState('');

    React.useEffect(() => {
        axios.get(`/api/applications?caseId=${idCase}`)
        .then((response) => {
            if (response.data.length === 0) {
                setError('Не найдено записей рассылки.');
            } else {
                setError('');
                setApplications(response.data);
            }
            setIsLoading(false);
        })
        .catch((error) => {
            console.error('Ошибка при получении данных:', error);
            setError(`Ошибка при загрузке записей рассылки: ${error.response?.data.message || error.message || 'Ошибка сети'}`);
            setIsLoading(false);
        });
    }, []);

    const appointmentAM = (caseId, email) => {
        setIsLoading(true);
        axios.put('/api/appointment', {
            caseId: caseId,
            email: email
        })
        .then(() => {
            setStatus('Арбитражный управляющий успешно назначен на дело.');
            setIsLoading(false);
            setTimeout(() => {
                setStatus('');
                if (onAppointmentSuccess) {onAppointmentSuccess()};
            }, 2300);
        })
        .catch((error) => {
            console.error('Ошибка при назначении арбитражного управляющего:', error);
            setError(`Ошибка при назначении арбитражного управляющего: ${error.response?.data.message || error.message || 'Ошибка сети'}`);
            setTimeout(() => {
                setError('');
            }, 2300);
            setIsLoading(false);
        });
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <>
                    {!status &&
                        !error &&
                        <>
                            <a>Письма отправлены следующим арбитражным управляющим:</a>
                            {applications.map((application) => (
                                <div className={styles.panelLine} key={application.id} style={application.user?.approval=='Отключен' ? {boxShadow: '0 0 0 1px red', backgroundColor: 'rgb(255, 222, 222)'} : {}}>
                                    <span style={{display: 'flex', flexDirection: 'column'}}>
                                        {application.user?.approval=='Активен' ? (
                                            <>
                                                <a>{application.user?.lastname} {application.user?.firstname} {application.user?.surname}</a>
                                            </>
                                        ) : (application.user?.approval=='Отключен' ? (
                                            <>
                                                <a>Учетная запись арбитражного управляющего деактивирована.</a>
                                            </>
                                        ) : (application.user?.approval=='На рассмотрении' ? (
                                            <>
                                                <a>Арбитражный управляющий проходит регистрацию и ждёт одобрения учётной записи.</a>
                                            </>
                                        ) : (
                                            <>
                                                <a>Арбитражный управляющий не зарегистрирован в системе.</a>
                                            </>
                                        )
                                        ))}
                                        <a style={{textDecoration: 'underline black', width: 'fit-content'}} href={`mailto:${application.email}`}>{application.email}</a>
                                        {application.status == 'Претендует' && 
                                        <a style={{display: 'flex', alignItems: 'center'}}>
                                            <svg style={{height: '20px', marginRight: '7px'}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="check-circle"><path fill="black" d="M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"></path></svg>
                                            Претендует
                                        </a>
                                        }
                                    </span>
                                    {application.status == 'Претендует' ? ( 
                                        <button type='button' className='button black' onClick={() => {appointmentAM(application.case_id, application.email)}}>Назначить</button>
                                    ) : (application.user &&
                                        <button type='button' className='button gray' onClick={() => {appointmentAM(application.case_id, application.email)}}>Назначить</button>
                                    )
                                    }
                                </div>
                            ))}
                        </>
                    }
                </>
            )}
            {error && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{error}</a>}
            {status && <a className={styles.statusPanel}><img src='/img/icons/check-circle.svg' alt='Статус' />{status}</a>}
        </>
    );
};

export default AgreedAMsForCase;
